
export const storePlace = [
    {
      id: 1,
      title: "Air Terjun Manggar",
      img: "img/air-terjun-manggar.jpg",
      price: 10,
      company: "Kalimantan - Barat",
      info:
        "Air Terjun Mananggar  yang sering juga disebut Air Terjun Melanggar, Menanggar, atau Banangar merupakan Niagara dari Borneo.  Air terjun yang berupa patahan Sungai Landak ini berada di Hulu Sungai Landak. Tepatnya di Kecamatan Air Besar, Kabupaten Landak. Untuk menuju Air Terjun Mananggar ini dibutuhkan waktu enam hingga tujuh jam perjalanan dari Pontianak hingga ke Kecamatan Air Besar, lalu dari sana perjalanan dilanjutkan menggunakan perahu.  Tapi jangan syedih, perjalanan panjang dan melelahkan Boboers akan terbayar lunas dengan kepuasan melihat keindahan ribuan tetes air yang jatuh dari ketinggian sekitar 600 meter, dan bersatu kedalam sebuah danau luas ditengah hutan tropis",
      inCart: true,
      count: 0,
      total: 0
    },
    {
      id: 2,
      title: "Bukit Kelam",
      img: "img/bukit-kelam.jpg",
      price: 16,
      company: "Kalimantan Barat",
      info:
        "Dengan tinggi sekitar 900 Mdpl, Bukit Kelam telah menjadi salah satu ikon wisata di Sintang, Kalimantan Barat. Bukit Kelam adalah sebongkah batu raksasa monolit, sehingga sering diklaim sebagai baru terbesar di dunia.  Selain kekokohannya yang menarik, Bukit Kelam juga menawarkan pemandangan alam yang eksotis. Dari atas puncak bukit ini, terlihat kota Sintang dan hutan yang terhampar luas.  Untuk mendaki sampai puncak, di Bukit Kelam ini ini sudah dibangun tangga untuk mempermudah pendakian.  Selama perjalanan menuju puncak Boboers akan disuguhi pemandangan indah khas hutan Kalimantan. Bahkan ada beberapa pohon yang langka..",
      inCart: false,
      count: 0,
      total: 0
    },
    {
      id: 3,
      title: "Bukit penjamur",
      img: "img/bukit-penjamur.jpg",
      price: 8,
      company: "Kalimantan Barat",
      info:
        "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrifyLokasi Bukit Jamur ini terletak di Kabupaten Bengkayang, tepatnya di Kelurahan Bumi Emas Jaku Malunu, Kalimantan Barat. Jarak Bukit Jamur kurang lebih 6 km dari pusat kota Bengkayang. Letak lokasi ini memang sangat strategis dan sangat mudah diakses. Dari Bukit Jamur ini Boboers dapat melihat indahnya lautan awan bak negeri dongeng, apalagi saat sang surya mulai menyembulkan sinarnya secara perlahan, dijamin pemandangan ini akan menjadi salah satu moment terbaik seumur hidup..",
      inCart: false,
      count: 0,
      total: 0
    },
    {
      id: 4,
      title: "Danau Sentarum",
      img: "img/danau-sentarum-saat-senja-1024x581.jpg",
      price: 18,
      company: "Kalimantan Barat",
      info:
        "Taman Nasional Danau Sentarum (TNDS) merupakan salah satu surga tersembunyi lainnya yang berada di Kalimantan Barat. Untuk menuju ke Danau Sentarum ini benar-benar menguras tenaga dan dompet, karena untuk bisa mencapai Danau Sentarum, dibutuhkan waktu 14 jam dari Kota Pontianak untuk perjalanan darat dan air dengan rute Pontianak-Sintang-Semitau. Lalu, dari Semitau menuju ke lokasi menggunakan perahu motor jurusan Lanjak (Biaya sewa perahu 1juta/hari perahu bisa diisi 6 orang).  Atau bisa pula dengan jalur udara melalui Pontianak-Putussibau sekitar dua jam dan dari Putussibau ke Nanga Suhaid dengan longboat sekitar tujuh jam..",
      inCart: false,
      count: 0,
      total: 0
    },
    {
      id: 5,
      title: "Pantai Temajuk",
      img: "img/pantai-temajuk-kalimantan-barat.jpg",
      price: 24,
      company: "Kalimantan Barat",
      info:
        "Pantai Temajuk terletak di desa Temajuk, desa yang berada di sebelah utara bagian barat pulau Kalimantan, hanya berjarak 4 kilometer dari Telok Melano, Malaysia. Desa ini secara administatif berada di Kecamatan Paloh, Kabupaten Sambas, Kalimantan Barat yang berbatasan langsung dengan Malaysia.  Desa ini memiliki garis pantai sangat panjang yakni sekitar 60 kilometer, dan disini terdapat lah Pantai Temajuk yang cantik itu..",
      inCart: false,
      count: 0,
      total: 0
    },
    {
      id: 6,
      title: "Pulau Selimpai",
      img: "img/pulau-selimpai.jpg",
      price: 17,
      company: "Kalimantan Barat",
      info:
        "Seperti sebuah pulau, Selimpai terpisah dengan daratan Kabupaten Sambas.  Sisi selatannya hingga ke bagian barat berbatasan dengan laut Natuna, sedangkan di sisi utaranya terjaga oleh Sungai Merabau.  Jadi saat di Pulau Selimpai ini Boboers dapat menikmati wisata lengkap, ada hutan pinus, pantai, laut dan sungai..",
      inCart: false,
      count: 0,
      total: 0
    },
    {
      id: 7,
      title: "Sungai Kapuas",
      img: "img/sungai-kapuas.jpg",
      price: 30,
      company: "Kalimantan Barat",
      info:
        "Sungai Kapuas merupakan sungai terpanjang di Indonesia dengan panjangnya mencapai 1.143 km.  Sungai Kapuas menjadi urat nadi bagi kehidupan masyarakat (terutama suku Dayak dan Melayu di sepanjang aliran sungai. Sebagai sarana transportasi yang murah, Sungai Kapuas dapat menghubungkan daerah satu ke daerah lain di wilayah Kalimantan Barat, dari pesisir Kalimantan Barat sampai ke daerah pedalaman Putussibau dihulu sungai ini.  Sungainya yang kaya memberikan mata pencarian bagi masyarakat sekitar sebagai pelayan tradisional.",
      inCart: false,
      count: 0,
      total: 0
    },
    {
      id: 8,
      title: "Rumah Panjang",
      img: "img/wisata-pontianak-4-Pontianak-Kota-mini.jpg",
      price: 2,
      company: "Kalimantan Barat",
      info:
        "Satu lagi destinasi wisata Kalimatan Barat dimana Toppers bisa mengagumi kemegahan arsitektur Nusantara adalah Rumah Betang Radakng. Replika rumah adat suku Dayak di Kalimantan Barat ini bahkan meraih rekor sebagai rumah adat terpanjang di Indonesia. Panjang rumah ini mencapai 138 meter dengan lebar 5 meter dan tinggi 7 meter..",
      inCart: false,
      count: 0,
      total: 0
    }
  ];
  
  export const detailPlace = {
    id: 1,
    title: "Air Terjun Mangga",
    img: "img/air-terjun-manggar.jpg",
    price: 10,
    company: "Kalimantan Barat",
    info:
      "Dengan tinggi sekitar 900 Mdpl, Bukit Kelam telah menjadi salah satu ikon wisata di Sintang, Kalimantan Barat. Bukit Kelam adalah sebongkah batu raksasa monolit, sehingga sering diklaim sebagai baru terbesar di dunia.  Selain kekokohannya yang menarik, Bukit Kelam juga menawarkan pemandangan alam yang eksotis. Dari atas puncak bukit ini, terlihat kota Sintang dan hutan yang terhampar luas.  Untuk mendaki sampai puncak, di Bukit Kelam ini ini sudah dibangun tangga untuk mempermudah pendakian.  Selama perjalanan menuju puncak Boboers akan disuguhi pemandangan indah khas hutan Kalimantan. Bahkan ada beberapa pohon yang langka...",
    inCart: false,
    count: 0,
    total: 0
  };
  